<template>
	<div id="retrospect" style="margin-top: 67px;">
		<div class="focuImg" ref="element">
			<div id="bannerimg" class="swiper-container bjh bannerimg">
				<img style="width: 100%;" src="/static/img/ygstbanner.png" alt="阳光食堂" />
			</div>
		</div>
		<div v-if="navBarFixed == true" style="height: 68px;"></div>
		<ul class="TopNav" :class="navBarFixed == true ? 'navBarWrap' :''">
			<li :class="TopNav==1?'active':''" @click="goAnchor('#a')">
				解决方案
			</li>
			<li :class="TopNav==2?'active':''" @click="goAnchor('#d')">
				产品服务
			</li>
			<li :class="TopNav==3?'active':''" @click="goAnchor('#e')">
				公司实力
			</li>
			<li :class="TopNav==4?'active':''" @click="goAnchor('#f')">
				城市合伙人招募
			</li>

		</ul>
		<!--<a class="gnld" ref="a">
			<div class="mddw" id="a"></div>-->
			<a class="flexY gnld" ref="a" >
			<div class="mddw" id="a"></div>
			<div class="width:1200px;margin:0 auto">
				<p class="biaoti" style="padding-top: 100px;margin-bottom: 70px;">阳光食堂解决方案</p>
				<!--<div class="gnldcon">
					<div @click="xz(1,'#a')" :class="xztab == 1 ? 'active' :''">阳光采供平台</div>
					<div @click="xz(2,'#b')" :class="xztab == 2 ? 'active' :''">阳光公示平台</div>
					<div @click="xz(3,'#c')" :class="xztab == 3 ? 'active' :''">智能监管平台</div>
				</div>-->
				<div class="textt">阳光采供平台</div>
				<div class="hbj" style=""></div>
				<div style="margin-top: 45px;display: flex;margin-left: 50px;">
					<div style="padding-top: 20px;margin-right: 10px;">
						<img src="../../static/img/cgpt_img_syt.png" /></div>
					<div><img src="../../static/img/cgpt_img_bzt.png" /></div>

				</div>
			</div>
		</a>
		<a class="gnld1" ref="b">
			<div class="mddw" id="b"></div>
			<div class="gnld1con">
				<div style="margin-left: 40px;">
					<div class="item" style="margin-top: 150px;">
						<div class="itemright" style="">
							<div class="itemt">阳光菜谱</div>
							<div class="itemcon">每日食谱公示，存档留案，依据可查</div>
						</div>
						<div>
							<img src="../../static/img/zspt_icon_gycp.png" /></div>
					</div>
					<div class="item" style="margin-top: 85px;">
						<div class="itemright" style="">
							<div class="itemt">采购日报</div>
							<div class="itemcon">每日商品采购信息公布、全程追溯</div>
						</div>
						<div>
							<img src="../../static/img/zspt_icon_cgrb.png" /></div>
					</div>
					<div class="item" style="margin-top: 110px;">
						<div class="itemright" style="">
							<div class="itemt">营养指导</div>
							<div class="itemcon">食品营养指数，各项机能信息展示</div>
						</div>
						<div>
							<img src="../../static/img/zspt_icon_yyzd.png" /></div>
					</div>
				</div>
				<div style="margin-left: 40px;margin-right:50px ;">
					<div style="padding-top: 38px;padding-bottom: 26px;color: #1AC4A3;font-size: 36px;height: 36px;line-height: 36px;"  class="textt">阳光公示平台</div>
					<img src="../../static/img/zspt_img_syt.png" /></div>
				<div>
					<div class="item" style="margin-top: 150px;">
						<div>
							<img src="../../static/img/zspt_icon_hczb.png" /></div>
						<div class="itemleft">
							<div class="itemt">后厨直播</div>
							<div class="itemcon">明厨亮灶，后厨动态实时了解</div>
						</div>

					</div>
					<div class="item" style="margin-top: 85px;">
						<div>
							<img src="../../static/img/zspt_icon_yjfk.png" /></div>
						<div class="itemleft">
							<div class="itemt">意见反馈</div>
							<div class="itemcon">支持消费者进行意见反馈和投诉</div>
						</div>

					</div>
					<div class="item" style="margin-top: 110px;">
						<div>
							<img src="../../static/img/zspt_icon_zzxc.png" /></div>
						<div class="itemleft">
							<div class="itemt">自助选餐</div>
							<div class="itemcon">个性化点餐，方便便捷</div>
						</div>

					</div>
				</div>
			</div>
		</a>
		<a class="gnld2" ref="c">
			<div class="mddw" id="c"></div>
			<div style="padding-top: 38px;color: #333" class="textt">智能监管平台</div>
			<div class="hbj" style=""></div>
			<div style="display: flex;margin-left: 40px;padding-top: 75px;">
				<div class="gnld2left" style="">
					<div v-for="(item,index) in list" @click="xxgsxz(index)" :key="index" :class="xxgsxztab == index ? 'active1' :''" class="gnld2leftitem">
						<div class="listitem">
							<div class="name">{{item.name}}</div>
							<div class="con">{{item.con}}</div>
							<div class="jt jt1" v-if="xxgsxztab==index"><img :src="item.src2" /></div>
							<div v-else class="jt"><img :src="item.src1" /></div>
						</div>
					</div>
				</div>
				<div class="gnld2right" style="margin-left: 90px;margin-top: 24px;">
					<div v-for="(item,index) in list1" :key='index' v-if="xxgsxztab==index">
						<p class="gnld2righttilte">{{item.name}}</p>
						<img src="/static/img/jgpt_icon_Square.png" alt="" />
						<div style="margin-left: 6px;">
							<div class="flex" v-if="xxgsxztab==index" style="flex-wrap: wrap;">
								<div class="flex" style="margin-top: 30px;margin-bottom: 18px;" v-for="(item1,index1) in item.list" :key="index1">
									<div class="yuan"></div>
									<div class="righttext">{{item1}}</div>
								</div>
							</div>
						</div>
						<img :src="item.src" style="margin-left: 56px;margin-top: 48px;" />
					</div>
				</div>
			</div>
		</a>
		<a class="gnld3" ref="d">
			<div class="mddw" id="d"></div>
			<p class="biaoti1" style="padding-top: 60px;margin-bottom: 55px;">智能产品</p>
			<div class="flex zncp">
				<div @click="cpxz(1)" :class="cpxztab == 1 ? 'zncpactive' :''">智能溯源秤</div>
				<div @click="cpxz(2)" :class="cpxztab == 2 ? 'zncpactive' :''">食品安全检测仪</div>
			</div>
			<div class="gnld3con">
				<div v-if="cpxztab==1" class="cpxz1">
					<img src="/static/img/zncp_img_syc.png" style="margin: 0px auto;padding-top: 62px;" />
					<p>食品来源可追溯</p>
					<p>打印订单</p>
					<p>现场核磅</p>
					<p>统计对账</p>
					<p>供应商订单自动接入</p>
					<p>政府部门实时监管</p>
					<p>进货透明公开</p>
				</div>
				<div v-if="cpxztab==2" class="cpxz2">
					<img src="/static/img/zncp_img_spjcy.png" style="margin: 0px auto;padding-top: 84px;" />
					<p>多通道独立检测</p>
					<p>安全可靠信赖度高</p>
					<p>批量打印检测结果</p>
					<p>检测数据自动上传</p>

				</div>
			</div>
		</a>
		<a class="gnld4" ref="e">
			<div class="mddw" id="e"></div>

			<p class="biaoti1" style="padding-top: 130px;margin-bottom: 90px;">阳光食堂·服务案例</p>
			<div class="flex" style="flex-wrap: wrap;width: 1200px;margin: 0 auto;justify-content: space-between;flex-direction: row;">
				<img v-for="(item,index) in list2" :key="index" :src="item" style="margin-bottom: 30px;" />
			</div>
			<img src="/static/img/img_yzfw.png" style="width: 100%;margin-top: 120px;" alt="阳光食堂" />
			<p class="biaoti" style="padding-top: 120px;margin-bottom: 90px;font-weight: 400;color:#000201;">360°全方位服务体系</p>
			<div class="flex gnld4con">
				<div class="gnld4item" v-for="(item,index) in list3" :key="index">
					<img :src="item.src" />
					<div class="gnld4name">{{item.name}}</div>
					<div class="gnld4con" v-html="item.con"></div>
				</div>
			</div>
		</a>
		<div class="zm" style="position: relative;" ref="f">
			<div class="mddw" id="f"></div>
			<img src="/static/img/img_cshhr.png" style="width: 100%;" alt="" />
		</div>
		<div class="footerbox" >

			<div class="footerboxTop">
				<div class="list1">
					<p class="p1">联系我们</p>
					<div class="xian"></div>
					<p class="p2">服务热线</p>
					<p class="p3">0571-87357305</p>
					<p class="p2">公司邮箱</p>
					<p class="p3">zjax@ansuw.com</p>
				</div>
				<div class="list2">
					<p class="p1">产品服务</p>
					<div class="xian"></div>
					<p class="p1" style="line-height: 45px;margin: 0;">软件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a href="http://www.ax168.com/system?activeIndex=0">食品追溯系统</a>
						<a href="http://www.ax168.com/system?activeIndex=1">食品检测系统</a>
						<a href="http://www.ax168.com/system?activeIndex=2">市场运营系统</a>
						<a href="http://www.ax168.com/system?activeIndex=3">商家管理系统</a>
						<a href="http://www.ax168.com/system?activeIndex=4">会员营销系统</a>
						<a href="http://www.ax168.com/system?activeIndex=5">网上菜场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=6">市场招商系统</a>
						<a href="http://www.ax168.com/system?activeIndex=7">电子结算系统</a>
						<a href="http://www.ax168.com/system?activeIndex=8">智能巡查系统</a>
						<a href="http://www.ax168.com/system?activeIndex=9">数据展示系统</a>
						<a href="http://www.ax168.com/system?activeIndex=10">智慧农场系统</a>
						<a href="http://www.ax168.com/system?activeIndex=11">智慧禽畜系统</a>
						<a href="http://www.ax168.com/system?activeIndex=12">智慧水产系统</a>
					</div>
					<p class="p1" style="line-height: 45px;margin: 0;">硬件产品</p>
					<div style="display: flex;flex-wrap: wrap;">
						<a>智慧农贸追溯电子秤</a>
						<a>商户信用公示屏</a>
						<a>放心农贸触摸一体机</a>
						<a>数据大屏</a>
					</div>
				</div>
				<div class="list3">
					<p class="p1">关于我们</p>
					<div class="xian"></div>
					<p class="p2">
						<a href="http://www.ax168.com/about/#a">企业简介</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#b">企业优势</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#c">资质荣誉</a>
					</p>
					<p class="p2">
						<a href="http://www.ax168.com/about/#d">企业特色</a>
					</p>
				</div>
			</div>
			<div class="footerboxC">
				<div class="xian"></div>
				<div class="textList">
					<p>解决方案</p>
					<p>
						<a href="http://www.ax168.com/publicity">智慧农贸解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/ygst">阳光厨房解决方案</a>
					</p>
					<p>
						<a href="http://www.ax168.com/zycpzs">重要产品追溯解决方案</a>
					</p>
				</div>
				<div class="xian"></div>
			</div>
			<div class="footerboxb">
				<p>地址： 浙江省杭州市西湖区西园八路11号一期D座506-507</p>
        <p style="cursor: pointer" @click="handNavGx">{{ICP_text}}</p>
				<p>公安部备案号：33010602001517</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.min.css'
	export default {
		data() {
			return {
				navBarFixed: false,
				gengduo: false,
				TopNav: 1,
				xztab: 1,
				xxgsxztab: 0,
				cpxztab: 1,
				list: [{
					name: '01',
					con: "信息公示管理",
					src1: '/static/img/jgpt_forward_gray.png',
					src2: '/static/img/jgpt_forward_yellow.png'
				}, {
					name: '02',
					con: "出入库管理",
					src1: '/static/img/jgpt_forward_gray.png',
					src2: '/static/img/jgpt_forward_yellow.png'
				}, {
					name: '03',
					con: "安全管理",
					src1: '/static/img/jgpt_forward_gray.png',
					src2: '/static/img/jgpt_forward_yellow.png'
				}, {
					name: '04',
					con: "员工管理",
					src1: '/static/img/jgpt_forward_gray.png',
					src2: '/static/img/jgpt_forward_yellow.png'
				}, {
					name: '05',
					con: "统计报表",
					src1: '/static/img/jgpt_forward_gray.png',
					src2: '/static/img/jgpt_forward_yellow.png'
				}, ],
				list1: [{
					name: '信息公示管理',
					src: '/static/img/jgpt_img_xxgs.png',
					list: ["食品信息发布", '营养餐信息公示', '财务信息公示', '菜品采购信息公示']
				}, {
					name: '出入库管理',
					src: '/static/img/jgpt_img_crkgl.png',
					list: ["食材库管理", '订单验收入库', '快速出库登记', '盘存管理', '调拨管理']
				}, {
					name: '安全管理',
					src: '/static/img/jgpt_img_aqgl.png',
					list: ["消毒记录", '留样记录', '农残检测记录', '废弃物处理记录']
				}, {
					name: '员工管理',
					src: '/static/img/jgpt_img_yggl.png',
					list: ["电子档案", '晨检记录', '健康证过期提醒', '从业人员操作监督记录']
				}, {
					name: '统计报表',
					src: '/static/img/jgpt_img_tjbb.png',
					list: ["采购申请统计", '收支统计', '收发结存统计', '销售统计', '采购报表', '毛利报表']
				}, ],
				list2: ['/static/img/fwal_img_3.png', '/static/img/fwal_img_2.png',
					'/static/img/fwal_img_1.png', '/static/img/fwal_img_4.png',
					'/static/img/fwal_img_7.png', '/static/img/fwal_img_6.png',
					'/static/img/fwal_img_5.png', '/static/img/fwal_img_8.png'
				],
				list3: [{
					name: '专业客服支持',
					con: "一对一客服全程</br>在线服务",
					src: '/static/img/fwtx_icon_1.png'
				}, {
					name: '强大代运营服务',
					con: "优秀运营团队</br>提供可靠的运营服务",
					src: '/static/img/fwtx_icon_2.png'
				}, {
					name: '大数据分析',
					con: "专项领域的高超技术支持</br>在垂直市场获得领先优势",
					src: '/static/img/fwtx_icon_3.png'
				}, ],

			}
		},
		created: function() {
        let keys = Object.keys(this.ICP)
    let findIndex=  keys.findIndex(key=>{
       return  key.includes(window.location.host)
    })
    this.ICP_text =findIndex!=-1? this.ICP[keys[findIndex]]:this.ICP_text
			this.$emit('footer', false);
			this.$emit('footer1', false);
			this.$emit('footer2', true);

		},
		activated() {
			//			document.title = "安宣智慧农贸-智慧农贸方案-安宣农贸解决方案"
			document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
		},
		methods: {
      handNavGx(){
        window.open("https://beian.miit.gov.cn", '_blank')
      },
			xz(index,selector) {
				this.xztab = index
				this.$el.querySelector(selector).scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
			},

			xxgsxz(index) {
				this.xxgsxztab = index
			},
			cpxz(index) {
				this.cpxztab = index
			},
			goAnchor(selector) {
				this.$el.querySelector(selector).scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				});
			},
			watchScroll() {
				var scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
					var scrollTop =
									window.pageYOffset ||
									document.documentElement.scrollTop ||
									document.body.scrollTop;
								let a = this.$refs.a.offsetTop
								let b = this.$refs.b.offsetTop
								let c = this.$refs.c.offsetTop
								let d = this.$refs.d.offsetTop
								let e = this.$refs.e.offsetTop
												let f = this.$refs.f.offsetTop
								let height = this.$refs.element.offsetHeight

								if(scrollTop + 70 >= a) {
									this.TopNav = 1
								}
								if(scrollTop + 70 >= b) {

//									this.getData();
								}
								if(scrollTop + 70 >= c) {

								}
								if(scrollTop + 70 >= d) {
										this.TopNav = 2
								}
								if(scrollTop + 250 >= e) {
										this.TopNav = 3
								}
								if(scrollTop + 250 >= f) {
										this.TopNav = 4
								}

								if(scrollTop > height) {
									this.navBarFixed = true;
								} else {
									this.navBarFixed = false;
								}
			}
		},

		mounted() {
			//banner轮播
			var swiper = new Swiper('.bannerimg', {
				pagination: '.swiper-pagination',
				paginationClickable: true,
				centeredSlides: true,
				autoplay: 3000,
				autoplayDisableOnInteraction: false,
				speed: 800,
				loop: true,
				// initialSlide: 3,
			})
			// 鼠标悬停控制轮播
			var comtainer = document.getElementById('bannerimg');
			comtainer.onmouseenter = function() {
				swiper.stopAutoplay();
			};
			// 鼠标离开 继续轮播
			comtainer.onmouseleave = function() {
				swiper.startAutoplay();
			}
			//		var swiper = new Swiper('.swiper-container', {
			//				slidesPerView: 'auto',
			//				pagination: '.swiper-pagination',
			//			});
			window.addEventListener("scroll", this.watchScroll);
			var th = this
			window.onresize = function() { //监听屏幕的改变
				document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
			};
		},
		components: {

		}
	}
</script>
<style>
	@import url('../css/retrospect.css');
	@import url('../css/home.css');
	[v-cloak] {
		display: none !important;
	}

	#home_dataShow {
		box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
	}

	.navBarWrap {
		position: fixed;
		top: 0px;
		z-index: 99999999999999999;
		background-color: #fff;
		width: 100%;
	}

	.focuImg {
		position: relative;
		overflow: hidden;
	}

	.focuImg .li {
		background-color: #668fe7;
		position: absolute;
		border-radius: .3rem;
		color: #fff;
		font-size: .08rem;
		font-weight: 500;
		padding: .06rem .2rem .06rem .2rem;
		transition: all 2s;
		opacity: 0;
	}

	.focuImg .li1.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li2.active {
		transform: translateY(0px);
		opacity: 1;
	}

	.focuImg .li3.active {
		transform: translateX(0px);
		opacity: 1;
	}

	.focuImg .li1 {
		transform: translateX(-100px);
		width: .5rem;
		left: .75rem;
		bottom: .8rem;
	}

	.focuImg .li2 {
		transform: translateY(-100px);
		width: .75rem;
		right: 2.3rem;
		bottom: 1.38rem;
	}

	.focuImg .li3 {
		transform: translateX(100px);
		width: .65rem;
		right: 0.1rem;
		bottom: 1rem;
		z-index: 999999999999999999;
	}

	.swiper-container-horizontal>.swiper-pagination-bullets,
	.swiper-pagination-custom,
	.swiper-pagination-fraction {
		bottom: -40px;
	}

	.swiper-pagination-bullet {
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}

	.swiper-pagination-bullet-active {
		background: #fff;
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}
</style>
<style scoped>
	#home_dataShow .dataShow_box {
		width: 1500px;
	}

	.anli .iocBox li .bottomBox {
		position: absolute;
		bottom: 0;
		background-color: transparent !important;
		z-index: 0;
		height: 70px;
		line-height: 70px;
		padding-left: 19px;
	}

	.anli .iocBox li {
		margin-bottom: 39px !important;
	}

	.company_infoContect .guanzhu {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-bottom: 12px;
	}

	.company_infoContect .wxHao {
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-top: 10px;
	}

	.pc {
		padding-top: 67px;
	}

	html,
	body {
		position: relative;
		height: 100%;
	}

	body {
		background: #eee;
		font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
		font-size: 14px;
		color: #000;
		margin: 0;
		padding: 0;
	}

	.flex {
		display: flex;
	}

	.yuan {
		width: 10px;
		height: 10px;
		background: #BFCEFE;
		border-radius: 50%;
		margin-top: 5px;
	}
	.textt{

height: 40px;
font-size: 40px;
line-height: 40px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #517BFC;
text-align: center;
position: relative;
z-index: 2;
	}
	.hbj{
		width: 251px;
height: 18px;
background: #FEBC04;
opacity: 0.85;
margin: 0 auto;margin-top: -10px;
	}
	.TopNav {
		display: flex;
		/*box-shadow: 0px 14px 13px 0px rgba(112, 112, 149, 0.06);
		padding-left: 450px;*/
		/*padding-left: 470px;*/
		height: 70px;
		background: #FFFFFF;
		box-shadow: -2px 7px 9px 1px rgba(102, 102, 102, 0.1);
	}

	.TopNav li.active {
		border-bottom: 1px solid #00C59F;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(20, 20, 20, 1);

	}

	.TopNav {

		display: flex;
	  width: 100%;
	  /* width: 1200px; */
	  box-sizing: border-box;
	  justify-content: center;
		box-shadow: 0px 14px 13px 0px rgba(112, 112, 149, 0.06);
	  margin-bottom: 10px;
		/* padding-left: 450px; */
	 /* float: right; */
	}

	.TopNav li {
	 /* flex: 1;
	    flex-grow: 1; */
	  flex-shrink: 0;
		cursor: pointer;
		/* width: 120px; */
	  padding:0 14px;
		text-align: center;
		margin: 0 30px;
		height: 68px;
		line-height: 68px;
		display: inline-block;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
	}
	.gnld {
		height: 860px;
		background: #fff;
		position: relative;
		display: block;
		/*border: 1px solid red;*/
		width: 1200px;
		margin: 0 auto;
		margin-top: 10px;
	}

	.gnldcon {
		display: flex;
		border-bottom: 1px solid #F2F3F7;
		padding-left: 185px;
		padding-right: 210px;
		flex-direction: row;
		justify-content: space-between;
	}

	.gnldcon div {
		height: 35px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		line-height: 21px;
		color: #888888;
	}

	.gnldcon .active {
		border-bottom: 4px solid #517BFC;
		color: #517BFC;
		font-weight: bold;
	}

	.gnld1 {
		height: 690px;
		background: #F7F8FD;
		display: block;
		position: relative;
	}

	.gnld1con {
		/*border: 1px solid red;*/
		width: 1200px;
		margin: 0 auto;
		display: flex;
		/*padding-top: 26px;*/
	}

	.item {
		display: flex;
		margin-top: 65px;
	}

	.itemright {
		text-align: right;
		margin-right: 20px;
		padding-top: 19px;
		width: 290px;
	}

	.itemleft {
		text-align: left;
		margin-left: 20px;
		padding-top: 19px;
		width: 290px;
	}

	.itemimg {
		width: 57px;
		height: 57px;
	}

	.itemt {
		height: 20px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
	}

	.itemcon {
		height: 19px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		margin-top: 20px;
	}

	.gnld2 {
		height: 806px;
		width: 1200px;
		display: block;
		margin: 0 auto;
		position: relative;
		/*border: 1px solid red*/
	}

	.gnld2leftitem {
		width: 370px;
		height: 114px;
		color: #A0A3B6;
	}

	.listitem {
		display: flex;
		height: 36px;
		line-height: 36px;
		padding-top: 40px;
		margin-left: 26px;
	}

	.active1 {
		background: #FEB95C;
		color: #333333;
	}

	.gnld2leftitem .name {
		font-size: 36px;
		height: 36px;
	}

	.gnld2leftitem .con {
		height: 22px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		margin-left: 30px;
		width: 205px;
	}

	.gnld2leftitem .jt {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		/*border:1px solid red*/
	}

	.gnld2leftitem .jt img {
		margin: 10px auto;
	}

	.gnld2leftitem .jt1 {
		background: #fff;
	}

	.gnld2righttilte {
		height: 26px;
		font-size: 26px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		line-height: 26px;
		margin-bottom: 14px;
	}

	.righttext {
		width: 200px;
		margin-left: 7px;
		height: 20px;
		line-height: 20px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666666;
	}

	.gnld3 {
		width: 100%;
		height: 798px;
		background: #F7F8FD;
		display: block;
		position: relative;

	}

	.zncp {
		width: 1200px;
		height: 40px;
		font-size: 26px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #010C0C;
		margin: 0 auto;
	}

	.zncp div {
		width: 50%;
		text-align: center;
		line-height: 26px;
	}

	.zncpactive {
		border-bottom: 2px solid #3E88FE;
		color: #0273FE;
		font-weight: bold;
	}

	.gnld3con {
		width: 1200px;
		height: 520px;
		background: #FFFFFF;
		box-shadow: -6px 4px 21px 3px rgba(62, 126, 253, 0.06);
		margin: 0 auto;
	}

	.cpxz1,
	.cpxz2 {
		position: relative;
	}

	.cpxz1 p,
	.cpxz2 p {
		position: absolute;
		color: #fff;
		height: 20px;
		line-height: 20px;
		font-size: 20px;
		font-weight: bold;
	}

	.cpxz2 p {
		color: #333;
	}

	.cpxz1 p:nth-child(2) {
		top: 90px;
		left: 250px
	}

	.cpxz1 p:nth-child(3) {
		top: 82px;
		left: 792px
	}

	.cpxz1 p:nth-child(4) {
		top: 222px;
		left: 150px;
	}

	.cpxz1 p:nth-child(5) {
		top: 183px;
		left: 890px;
	}

	.cpxz1 p:nth-child(6) {
		top: 386px;
		left: 120px;
	}

	.cpxz1 p:nth-child(7) {
		top: 295px;
		left: 910px;
	}

	.cpxz1 p:nth-child(8) {
		top: 411px;
		left: 745px;
	}

	.cpxz2 p:nth-child(2) {
		top: 200px;
		left: 630px
	}

	.cpxz2 p:nth-child(3) {
		top: 200px;
		left: 955px
	}

	.cpxz2 p:nth-child(4) {
		top: 390px;
		left: 630px;
	}

	.cpxz2 p:nth-child(5) {
		top: 390px;
		left: 955px;
	}

	.gnld4 {
		height: 1587px;
		display: block;
		margin: 0 auto;
		position: relative;
		/*border: 1px solid red*/
	}

	.gnld4con {
		width: 990px;
		margin: 0 auto;
		flex-direction: row;
		justify-content: space-between;
	}

	.gnld4item {}

	.gnld4item img {
		margin: 0 auto;
	}

	.gnld4name {
		height: 23px;
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #202020;
		line-height: 32px;
		margin-bottom: 10px;
		text-align: center;
		line-height: 23px;
		margin-top: 40px;
	}

	.gnld4item:nth-child(3) .gnld4name:nth-child(2) {
		margin-top: 25px;
	}

	.gnld4con {
		height: 41px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #202020;
		line-height: 24px;
		text-align: center;
	}

	.gnld4con:nth-child(1) {
		width: 120px
	}

	.gnld4con:nth-child(2) {
		width: 155px
	}

	.gnld4con:nth-child(3) {
		width: 190px
	}

	/*.zm {
		height: 340px;
		color: #FFFFFF;
		background: url('../../static/img/img_cshhr.png') 0/100% 100%;
		text-align: center;
	}*/
	.mddw {
		position: absolute;
		top: -68px;
		width: 100%;
		height: 68px;
    left:0px;
		z-index: -1;
	}
	.fuwu li {
		width: 230px;
		text-align: center;
	}

	.fuwu li p {
		margin-top: 0;
	}

	.fuwu li .p1 {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		margin-top: 21px;
		margin-bottom: 33px;
	}

	.fuwu li .p2 {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(32, 32, 32, 1);
		line-height: 25px;
	}

	.biaoti {
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333;
		text-align: center;
		height: 30px;
		line-height: 30px;
	}

	.biaoti1 {
		height: 40px;
		font-size: 40px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		text-align: center;
		line-height: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/ygst.vue